<template>
    <div id="djArticleList" :class="$root.isMob() ? 'djArticleList mob' : ''" v-loading="loading">
        <div class="item" v-for="item in data" :key="item.id" @click="view(item)">
            <div class="img">
                <img :src="API + item.cover_img_text"/>
                <span class="tag" v-if="item.is_vr==2">VR</span>
            </div>
            <div class="title">
              <h3>{{ item.name }}</h3>
            </div>
            <div class="row">
              <div class="describeT1">
                  {{ item.describe }}
              </div>
              <div class="num">
                <i class="el-icon-user icon"></i>
                {{ item.total_examine_nums }}
              </div>
            </div>
            <div class="describe">
                {{ item.describe }}
            </div>
        </div>
        <div class="empty" v-if="data.length == 0">
          <el-empty description="暂无数据"></el-empty>
        </div>
    </div>
</template>
<script>
export default {
  name: 'djArticleList',
  props: {
    type : {
      type: String,
      default: "1"
    },
    clinet:{
      type: String,
      default: "web"
    }
  },
  watch: {
    "type"(){
      this.getDjArticle(this.type,1);
    },
    "clinet"(){
      this.getDjArticle(this.type,1);
    }
  },
  data() {
    return {
        data:[],
        API: window.config.api,
        loading:false,
    }
  },
  methods: {
    async getDjArticle(type='',page=1){
        this.loading = true;
        let data = await this.$root.getDjArticle('',type,page);    
        if(data){
          this.data = data.data.data;
          this.data.forEach(item => {            
            let isOut = false;
            //截取前150字符的简介
            if(item.describe.length > 150){
              isOut = true;
            }
            item.describe = item.describe.substring(0,150);
            if(isOut){
              item.describe = item.describe + "...";
            }
          });
          //剔除VR项目
          if(this.clinet == 'web'){
            this.data = this.data.filter(item => {
              return item.is_vr != 2;
            });
          }
          //剔除WEB项目
          if(this.clinet == 'vr'){
            this.data = this.data.filter(item => {
              return item.is_vr == 2;
            });
          }
        }   
        this.loading = false;
    },
    view(item){
      window.location.href = '/#/userCenter?djId='+item.id;
    },
  },
  created() {
    this.getDjArticle(this.type,this.page);
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped src="@/assets/css/lib/articleList.scss"></style>